import { ViewStateTypesEnum } from '@common/enums/viewstate-types';
import { IDeepCopy } from '@common/interfaces/i-deep-copy';

export class ViewStateDef implements IDeepCopy<ViewStateDef> {
    public Guid: string = null;
    public Title: string = null;
    public Current: boolean = false;
    public Type: ViewStateTypesEnum = null;

    private selected: boolean = false;
    public get Selected(): boolean {
        return this.selected;
    }
    public set Selected(value: boolean) {
        if (value !== this.selected) {
            this.selected = value;
            if (this.OnChange) {
                this.OnChange(this.selected);
            }
        }
    }

    public OnChange: (value: boolean) => any;

    constructor(guid: string, title: string) {
        this.Guid = guid;
        this.Title = title;
    }

    public toJSON() {
        return this.Guid;
    }

    public deepCopy(): ViewStateDef {
        const ret = new ViewStateDef(this.Guid, this.Title);
        ret.Selected = this.Selected;
        ret.Current = this.Current;
        ret.Type = this.Type;
        ret.Title = this.Title;
        return ret;
    }
}
